module.exports = __webpack_public_path__ + "static/media/PDS_logo_20220809 (1).939cf18a.jpg";